import { createApiRequest } from "../common";
import { DeleteOrgRequestContent } from '@equaliq/api-model';

export const deleteOrgApi = async (request: DeleteOrgRequestContent): Promise<void> => {
  const apiRequest = createApiRequest<void>('post', '/orgs/delete');
  return apiRequest(request);
};
